import React, { Component } from 'react';
import Search from 'antd/lib/input/Search';
import { SearchOutlined } from '@material-ui/icons';
import { Modal, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import ModalTransactionDetail from './modal_transaction_detail';
import { COLORS } from '../pages/theme';
import KeyboardShortcutWrapper from '../util/keyshortcuts/index';
import moment from 'moment';

class AnimatedSearchInput extends Component {
    constructor(props) {
        super(props)

        this.state = {
            focused: false,
            view_transaction_id: null,
            view_transaction_modal: false,
            searing_id: null
        }
    }

    getSelectedContent = () => {
        let ctx=this;

        navigator.clipboard.readText()
            .then(text => {
                let _t=atob(text);
                let _t_array=_t.split(",");
                if(moment(_t_array[1],"YYYY-MM-DD").isValid()){
                    ctx.setState({
                        searing_id:text,
                        view_transaction_id:text,
                        view_transaction_modal:true
                    })
                }else{
                    console.log('NOT VALID TEXT ', text);
                }
                
                
            })
            .catch(err => {
                console.error('Failed to read clipboard contents: ', err);
        });

    }

    render() {
        const { searing_id } = this.state;
        return (<>
            <KeyboardShortcutWrapper
                wrapperStyle={{
                    display: 'flex'
                }}
                trigger={`Alt+S,Alt+s`}
                label={"S"}
                onDown={() => {
                    // this.getSelectedContent()
                    this.setState({
                        focused: true
                    })
                }}
            >
                <SearchOutlined
                    style={{
                        fontSize: 24, marginLeft: 20, color: COLORS.secondary
                    }}
                    className='hand-cursor'
                    onClick={() => {
                        this.getSelectedContent()
                        this.setState({
                            focused: true
                        })
                    }}
                    titleAccess='Quick Transaction View' />
            </KeyboardShortcutWrapper>
            <Modal
                centered
                // title="ENTER TRANSACTION ID"
                className='transparent-modal'
                visible={this.state.focused}

                destroyOnClose
                onCancel={() => {
                    this.setState({
                        focused: false
                    })
                }}
            >
                <Title level={2}>ENTER TRANSACTION ID</Title>
                <Search
                    // autoFocus
                    value={searing_id}
                    onChange={(e) => {
                        this.setState({
                            searing_id: e.target.value
                        })
                    }}
                    placeholder="Transaction ID"
                    onSearch={value => {
                        if (value == null || value == "") {
                            message.error("Please enter transaction ID first")
                        } else {
                            this.setState({
                                view_transaction_modal: true,
                                view_transaction_id: value
                            })
                        }
                    }}
                    enterButton />

                <Modal
                    visible={this.state.view_transaction_modal}
                    width={'90%'}
                    destroyOnClose
                    footer={null}
                    className='transaction-modal'
                    centered
                    onCancel={() => {
                        this.setState({
                            view_transaction_modal: false,
                            view_transaction_id: null
                        })
                    }}
                >
                    <ModalTransactionDetail
                        isModal={true}
                        onClose={() => {
                            this.setState({
                                view_transaction_modal: false,
                                view_transaction_id: null,
                            })
                        }}
                        match={{
                            params: {
                                transaction_id: this.state.view_transaction_id
                            }
                        }}
                    />
                </Modal>
            </Modal>
            {/* <Search
            className={this.state.focused?'search-focused':'search-hidden'}
            style={{
                width:200,
                transition:'all 0.2s'
            }}
                suffix={<SearchOutlined />}
                onFocus={() => {
                    this.setState({
                        focused: true
                    })
                }}
                onBlur={() => {
                    this.setState({
                        focused: false
                    })
                }}
                // value={this.props.value}
                // onChange={(e)=>{
                //     this.props.onChange(e.target.value)
                // }}
                onSearch={(value)=>{
                    typeof this.props.onSearch==='function'&&this.props.onSearch(value)
                }}
            /> */}
        </>
        );
    }
}

export default AnimatedSearchInput;
